import React, { useState, useEffect } from "react";
import "./style.css";
import { host } from "../../config/Config";

export const AdminEducationPrices = () => {
    const [educationPrices, setEducationPrices] = useState([]);
    const [loading, setLoading] = useState(true);
    const [editingId, setEditingId] = useState(null);
    const [editForm, setEditForm] = useState({ educationType: "", price: 0 });
    const [message, setMessage] = useState({ text: "", type: "" });

    useEffect(() => {
        fetchEducationPrices();
    }, []);

    const fetchEducationPrices = async () => {
        try {
            const token = localStorage.getItem("jwt-vlada");
            console.log("Token exists:", !!token);
            console.log("Token value:", token);

            const response = await fetch(`${host}/api/v1/education-prices`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            console.log("Response status:", response.status);
            console.log("Response ok:", response.ok);

            if (response.ok) {
                const data = await response.json();
                setEducationPrices(data);
            } else {
                const errorText = await response.text();
                console.log("Error response:", errorText);
                showMessage("Greška prilikom učitavanja cena", "error");
            }
        } catch (error) {
            console.error("Error fetching education prices:", error);
            showMessage("Greška prilikom učitavanja cena", "error");
        } finally {
            setLoading(false);
        }
    };

    const handleEdit = (price) => {
        setEditingId(price.id);
        setEditForm({
            educationType: price.educationType,
            price: price.price,
        });
    };

    const handleSave = async (id) => {
        try {
            const response = await fetch(
                `${host}/api/v1/education-prices/${id}`,
                {
                    method: "PUT",
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${localStorage.getItem(
                            "jwt-vlada"
                        )}`,
                    },
                    body: JSON.stringify(editForm),
                }
            );

            if (response.ok) {
                showMessage("Cena uspešno ažurirana", "success");
                setEditingId(null);
                fetchEducationPrices();
            } else {
                showMessage("Greška prilikom ažuriranja cene", "error");
            }
        } catch (error) {
            console.error("Error updating price:", error);
            showMessage("Greška prilikom ažuriranja cene", "error");
        }
    };

    const handleCancel = () => {
        setEditingId(null);
        setEditForm({ educationType: "", price: 0 });
    };

    const showMessage = (text, type) => {
        setMessage({ text, type });
        setTimeout(() => setMessage({ text: "", type: "" }), 3000);
    };

    const formatPrice = (price) => {
        return new Intl.NumberFormat("sr-RS").format(price);
    };

    const educationTypeDisplayNames = {
        "hands-on": "Hands On",
        "look-and-learn": "Look and Learn",
        "one-on-one": "One on One",
        fade: "Fade Workshop",
        formation: "Formation Workshop",
        "creative-formation": "Creative Formation",
        fundamental: "Fundamental Workshop",
        online: "Online Education",
        "nine-week": "Nine Week Program",
        "twelve-week": "Twelve Week Program",
        "single-bundle": "PAKET: Sve jednodnevne edukacije",
        "workshop-bundle": "PAKET: Sve workshop edukacije",
        "beginner-bundle": "PAKET: Sve početničke edukacije",
        "online-bundle": "PAKET: Sve online edukacije",
    };

    const isBundlePrice = (type) => {
        return type.endsWith("-bundle");
    };

    if (loading) {
        return (
            <div className='admin-education-prices'>
                <h1>Učitavanje...</h1>
            </div>
        );
    }

    return (
        <div className='admin-education-prices'>
            <div className='admin-header'>
                <h1>Cene edukacija</h1>
            </div>

            {message.text && (
                <div className={`message ${message.type}`}>{message.text}</div>
            )}

            <div className='prices-table-container'>
                <h2 style={{ color: "#be9455", marginBottom: "20px" }}>
                    Individualne edukacije
                </h2>
                <table className='prices-table'>
                    <thead>
                        <tr>
                            <th>Tip edukacije</th>
                            <th>Cena</th>
                            <th>Akcije</th>
                        </tr>
                    </thead>
                    <tbody>
                        {educationPrices
                            .filter((p) => !isBundlePrice(p.educationType))
                            .map((priceItem) => (
                                <tr key={priceItem.id}>
                                    <td>
                                        {educationTypeDisplayNames[
                                            priceItem.educationType
                                        ] || priceItem.educationType}
                                    </td>
                                    <td>
                                        {editingId === priceItem.id ? (
                                            <input
                                                type='number'
                                                step='0.01'
                                                value={editForm.price}
                                                onChange={(e) =>
                                                    setEditForm({
                                                        ...editForm,
                                                        price: parseFloat(
                                                            e.target.value
                                                        ),
                                                    })
                                                }
                                                className='edit-input'
                                            />
                                        ) : (
                                            formatPrice(priceItem.price)
                                        )}
                                    </td>
                                    <td>
                                        {editingId === priceItem.id ? (
                                            <div className='action-buttons'>
                                                <button
                                                    onClick={() =>
                                                        handleSave(priceItem.id)
                                                    }
                                                    className='btn-save'
                                                >
                                                    Sačuvaj
                                                </button>
                                                <button
                                                    onClick={handleCancel}
                                                    className='btn-cancel'
                                                >
                                                    Otkaži
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                onClick={() =>
                                                    handleEdit(priceItem)
                                                }
                                                className='btn-edit'
                                            >
                                                Izmeni
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            <div
                className='prices-table-container'
                style={{ marginTop: "40px" }}
            >
                <h2
                    style={{
                        color: "#be9455",
                        marginBottom: "20px",
                        fontSize: "28px",
                    }}
                >
                    Cene sa popustom za kupovinu više edukacija
                </h2>
                <table className='prices-table bundle-table'>
                    <thead>
                        <tr>
                            <th>Paket</th>
                            <th>Cena</th>
                            <th>Akcije</th>
                        </tr>
                    </thead>
                    <tbody>
                        {educationPrices
                            .filter((p) => isBundlePrice(p.educationType))
                            .map((priceItem) => (
                                <tr key={priceItem.id} className='bundle-row'>
                                    <td>
                                        {educationTypeDisplayNames[
                                            priceItem.educationType
                                        ] || priceItem.educationType}
                                    </td>
                                    <td>
                                        {editingId === priceItem.id ? (
                                            <input
                                                type='number'
                                                step='0.01'
                                                value={editForm.price}
                                                onChange={(e) =>
                                                    setEditForm({
                                                        ...editForm,
                                                        price: parseFloat(
                                                            e.target.value
                                                        ),
                                                    })
                                                }
                                                className='edit-input'
                                            />
                                        ) : (
                                            formatPrice(priceItem.price)
                                        )}
                                    </td>
                                    <td>
                                        {editingId === priceItem.id ? (
                                            <div className='action-buttons'>
                                                <button
                                                    onClick={() =>
                                                        handleSave(priceItem.id)
                                                    }
                                                    className='btn-save'
                                                >
                                                    Sačuvaj
                                                </button>
                                                <button
                                                    onClick={handleCancel}
                                                    className='btn-cancel'
                                                >
                                                    Otkaži
                                                </button>
                                            </div>
                                        ) : (
                                            <button
                                                onClick={() =>
                                                    handleEdit(priceItem)
                                                }
                                                className='btn-edit'
                                            >
                                                Izmeni
                                            </button>
                                        )}
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};
